// Markdown wraps block components in the flow of the prose, so the grid carries
// the same vertical rhythm the surrounding paragraphs have.
.root {
	margin-block: var(--mantine-spacing-lg);
}

// Workflow filters, drawn like the Database / Agent Memory switch: a pill track
// on the card surface, with a lilac thumb that slides under the active filter.
// The chips keep their own size; only the treatment is the switch's.
.track {
	position: relative;
	display: inline-flex;
	flex-wrap: wrap;
	gap: 2px;
	padding: 4px;
	border-radius: 999px;
	background-color: var(--docs-card);

	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}

.thumb {
	position: absolute;
	z-index: 0;
	top: 4px;
	bottom: 4px;
	left: 0;
	border-radius: 999px;
	background-color: var(--docs-accent);
	transition: transform .28s cubic-bezier(.4, 0, .2, 1), width .28s cubic-bezier(.4, 0, .2, 1);

	@media (prefers-reduced-motion: reduce) {
		transition: none;
	}
}

.chip {
	position: relative;
	z-index: 1;
	padding: 0.3125rem 0.875rem;
	border: none;
	border-radius: 999px;
	background: transparent;
	color: var(--mantine-color-slate-3);
	font-size: var(--mantine-font-size-sm);
	cursor: pointer;
	transition: color .28s ease;

	@include light {
		color: var(--mantine-color-slate-6);
	}

	&:hover {
		color: var(--mantine-color-bright);
	}

	&[data-active] {
		color: var(--docs-accent-contrast);

		@include light {
			color: var(--docs-accent-contrast);
		}
	}
}

.anchor {
	display: block;
	height: 100%;
}

// Same surface and hover as the labs cards, so the two grids read as one system.
.card {
	display: flex;
	flex-direction: column;
	height: 100%;
	padding: var(--mantine-spacing-lg);
	background: var(--docs-card);
	transition: background 200ms ease;

	.anchor:hover & {
		background: var(--docs-card-hover);

		.name {
			color: var(--docs-accent-text);
		}
	}
}

.name {
	transition: color 200ms ease;
}

// Light mode draws the edge with a 1px line instead of a fill.
.card {
	@include light {
		border: 1px solid var(--surreal-border-default);
	}
}
